/**
 * Created by spepa on 26.01.2024
 */

const LandmarkPreview = function (unit) {
    UnitComponent.call(this, unit);
};

LandmarkPreview.prototype = Object.create(UnitComponent.prototype);
LandmarkPreview.prototype.constructor = LandmarkPreview;

LandmarkPreview.prototype.handleClick = function () {
    const landmark = cleverapps.achievements.listByActiveExpeditions().filter((landmark) => landmark.stage === this.unit.stage)[0];

    if (landmark) {
        this.unit.squeeze();

        cleverapps.focusManager.display({
            focus: "LandmarkPreview",
            action: function (f) {
                new DonorProgressWindow(landmark);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
    return true;
};